import { Area, SceneObjects } from '@types'

export default function isArea(area?: SceneObjects | string): area is Area {
  if (typeof area === 'string') return area.startsWith('areas_')
  return !!area && area?.type === 'areas'
}
